export default "__VITE_ASSET__XlQYXmC3__"